import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/modules/shared.module';
import { XpKitModule } from '@shared/modules/xp-kit.module';
import { AddOperatorVehicleComponent } from '../vehicles/components/add-operator-vehicle/add-operator-vehicle.component';
import { AddDriversToVehicleDialogComponent } from '../vehicles/components/add-drivers-to-vehicle-dialog/add-drivers-to-vehicle-dialog.component';
import { EditBoundaryFeeDialogComponent } from '../vehicles/components/edit-boundary-fee-dialog/edit-boundary-fee-dialog.component';
import { OperatorVehicleDetailComponent } from '../vehicles/components/operator-vehicle-detail/operator-vehicle-detail.component';
import { OperatorVehicleInsightsComponent } from '../vehicles/components/operator-vehicle-insights/operator-vehicle-insights.component';
import { OperatorVehiclesComponent } from '../vehicles/components/operator-vehicles.component';
import { OperatorDatePickerModule } from './operator-date-picker.module';

@NgModule({
	declarations: [
		OperatorVehiclesComponent,
		AddOperatorVehicleComponent,
		OperatorVehicleDetailComponent,
		OperatorVehicleInsightsComponent,
		EditBoundaryFeeDialogComponent,
		AddDriversToVehicleDialogComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		SharedModule,
		OperatorDatePickerModule,
		XpKitModule
	],
	exports: [
		OperatorVehiclesComponent,
		AddOperatorVehicleComponent,
		OperatorVehicleDetailComponent,
		OperatorVehicleInsightsComponent,
		EditBoundaryFeeDialogComponent,
		AddDriversToVehicleDialogComponent
	]
})
export class OperatorVehiclesSharedModule { }
